import React from 'react';

interface ISquare_02 {
    fill: string;
    id?: string;
}

const Square_02: React.FC<ISquare_02> = ({ fill, id }) => {
  return (
  <svg width="344" height="344" viewBox="0 0 344 344" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1759_574" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="344" height="344">
  <path d="M0 344H344V-1.00732e-05H0V344Z" fill={fill}/>
  </mask>
  <g mask="url(#mask0_1759_574)">
  <rect x="78" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="30" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="126" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="6" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="102" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="54" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="150" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="90" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="42" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="138" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="18" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="114" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="66" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="162" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="84" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="36" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="132" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="12" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="108" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="60" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="156" y="-541" width="2" height="1426" fill={fill}/>
  <rect y="-541" width="2" height="1426" fill={fill}/>
  <rect x="96" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="48" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="144" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="24" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="120" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="72" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="168" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="174" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="270" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="222" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="318" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="198" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="294" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="246" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="342" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="186" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="282" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="234" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="330" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="210" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="306" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="258" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="180" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="276" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="228" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="324" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="204" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="300" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="252" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="192" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="288" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="240" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="336" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="216" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="312" y="-541" width="2" height="1426" fill={fill}/>
  <rect x="264" y="-541" width="2" height="1426" fill={fill}/>
  </g>
  </svg>
  );
  };
  export default Square_02;
